module.exports = __webpack_public_path__ + "static/media/login.b9e980fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/login/login.jpg
// module id = 763
// module chunks = 0